module.exports = __webpack_public_path__ + "prod/1.42.2/img/humanRes.86e5e952.png";